import React from 'react';
import PropTypes from 'prop-types';
import {
  Spacer,
  Visible,
  BreakPointItem,
  BREAKPOINTS,
} from '@tfecom-thermofisher/react-komodo-design';

import { Icon, Message } from 'src/core/components';
import messages from './messages';
import './TabNode.style.scss';

const TabNode = ({
  tab,
  onClick,
  content
}) => {
  const activeClassName = 'dna-tab-node--active';
  const isChecked = tab.isComplete && !tab.isActive;

  return (
    <div className="dna-tab-wrapper">
      <div
        data-testid={`tab-${tab.order}`}
        className="dna-tab-node"
        onClick={() => onClick(tab)}
      >
        <div
          className={`dna-tab-node__step ${
            tab.isActive ? activeClassName : ''
          }`}
        >
          <Visible when={isChecked}>
            <Icon name="checkmark-mono" size={24} />
          </Visible>
          <Visible when={!isChecked}>{tab.order + 1}</Visible>
        </div>
        <div
          className={`dna-tab-node__line ${
            tab.isActive ? activeClassName : ''
          }`}
        />
      </div>
      <div
        className={`dna-tab-title ${
          tab.isActive ? 'dna-tab-title--active' : ''
        }`}
      >
        <Message message={tab.title} />
        <BreakPointItem max={BREAKPOINTS.md} includeMax>
          <Visible when={tab.isActive}>
            <Spacer top="30" />
            {content}
          </Visible>
        </BreakPointItem>
        <Visible when={tab.isOptional}>
          <div className="dna-tab-title__optional">
            <Message message={messages.optional} />
          </div>
        </Visible>
      </div>
    </div>
  );
};

TabNode.propTypes = {
  tab: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired
};

export default TabNode;
